import { useEffect } from 'react'

import { useAsync } from 'core/ui/hooks/useAsync'

import { updateProNumber } from '../../use-cases/updateProNumber'

export function useUpdateProNumber({ onUpdate }: { onUpdate: () => void }) {
  const { call, result, status, isDone, reset } = useAsync(updateProNumber)

  useEffect(() => {
    if (isDone) {
      onUpdate()
      reset()
    }
  }, [isDone, onUpdate, reset])

  return { updateProNumber: call, updateProNumberResult: result, updateProNumberStatus: status }
}
